/** Documents - a place of ADR-0212's menu (Records): Library and Bulk edit.
 *
 * The Library is this screen (`documents/Library.tsx`); Bulk edit is the spreadsheet round trip that
 * has always been at `/bulk` and is its own tab address. `/evidence` redirects here
 * (`routeTable.ts` `REDIRECTS`), and a document's own page stays at `/evidence/{id}`.
 */

import { RequireSession } from "../shell/RequireSession";
import { LibraryTab } from "./documents/Library";

export function DocumentsScreen() {
  return (
    <RequireSession>
      <LibraryTab />
    </RequireSession>
  );
}
